import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'app-payment-header',
    templateUrl: './payment-header.component.html',
    styleUrls: ['./payment-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class PaymentHeaderComponent {
  @Input() selectedHeader: string;
  @Input() tableCategory: string;
}
